import { maskCEP, maskCNPJ, maskCPF, maskPhone, maskReal, maskSSN, maskUSPhone, maskZipCode, maskDollar } from '@helpers';
import { Input, InputProps } from 'antd';
import { useEffect, useRef, useState } from 'react';

type MaskType = 'money' | 'dollar' | 'phone' | 'usphone' | 'cep' | 'cnpj' | 'cpf' | 'ssn' | 'zipCode';

interface InputMaskProps extends InputProps {
  mask?: MaskType;
}

export const InputMask = ({
  mask,
  value,
  onChange,
  ...props
}: InputMaskProps) => {
  const [internalValue, setInternalValue] = useState(value || '');
  const previousLengthRef = useRef<number>(String(internalValue).length);

  useEffect(() => {
    if (value !== undefined) {
      setInternalValue(value);
      previousLengthRef.current = String(value).length;
    }
  }, [value]);

  const stripNonNumeric = (val: string): string => {
    return val.replace(/\D/g, '');
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let formattedValue = e.target.value;
    const isDeleting = formattedValue.length < previousLengthRef.current;
    const rawValue = stripNonNumeric(formattedValue);

    previousLengthRef.current = formattedValue.length;

    if (isDeleting && (mask === 'phone' || mask === 'usphone')) {
      const numericValue = stripNonNumeric(String(internalValue));
      if (numericValue.length > 0) {
        const newRawValue = numericValue.slice(0, -1);
        formattedValue = mask === 'usphone' ? maskUSPhone(newRawValue) : maskPhone(newRawValue);
      } else {
        formattedValue = '';
      }
    } else {
      switch (mask) {
        case 'money':
          formattedValue = maskReal(formattedValue);
          break;

        case 'dollar':
          formattedValue = maskDollar(formattedValue);
          break;

        case 'phone':
          formattedValue = maskPhone(rawValue);
          break;

        case 'usphone':
          formattedValue = maskUSPhone(rawValue);
          break;

        case 'cep':
          formattedValue = maskCEP(formattedValue);
          break;

        case 'cnpj':
          formattedValue = maskCNPJ(formattedValue);
          break;

        case 'cpf':
          formattedValue = maskCPF(formattedValue);
          break;

        case 'ssn':
          formattedValue = maskSSN(formattedValue);
          break;

        case 'zipCode':
          formattedValue = maskZipCode(formattedValue);
          break;
      }
    }

    setInternalValue(formattedValue);
    previousLengthRef.current = formattedValue.length;

    if (onChange) {
      onChange({ ...e, target: { ...e.target, value: formattedValue } });
    }
  };

  return <Input {...props} value={internalValue} onChange={handleChange} />;
};
